module.exports = __webpack_public_path__ + "img/ic_steps_off.a6c08d3d.svg";